import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 유저 휴가 사용 월별 정보
 * @param no : int
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
const useVacationMonthTotal =(no)=>{
    return customAxios.post(myIpAddress+'/vacation/useVacationMonthTotal',
        {mem_no:no});
}
export default useVacationMonthTotal;
